import { render, staticRenderFns } from "./TheHeaderMaster.vue?vue&type=template&id=155674c6"
import script from "./TheHeaderMaster.vue?vue&type=script&lang=ts"
export * from "./TheHeaderMaster.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutsHeaderTheLogo: require('/usr/src/nuxt-app/components/layouts/header/TheLogo.vue').default})
